<cnaf-contactermacaf-complet-web *ngIf="contexte === 'web'" #wrapper></cnaf-contactermacaf-complet-web>
<cnaf-contactermacaf-complet-mobile *ngIf="contexte === 'mobile'" #wrapper></cnaf-contactermacaf-complet-mobile>
<ng-container *ngIf="wrapper">
    <ng-container *ngTemplateOutlet="wrapper.componentTemplate"></ng-container>
</ng-container>
